import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchTruck } from '@/features/trucks/api'

import { truckParamsSchema } from '../-models/truck-params'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/trucks/$truckId'
)({
  parseParams: (params) => parse(truckParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, truckId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      truck: await fetchTruck(
        {
          tenantKey,
          truckId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.truck.name
    }
  ]
})
